import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Container, Divider, Typography } from '@material-ui/core';

import CodeSnippet from '@hydra/common/components/CodeSnippet';
import { Translate } from '@hydra/common/components';

import * as fetcher from '@hydra/utils/fetcher';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 2.5,
    padding: 0,
    backgroundColor: theme.palette.background.paper
  },
  heading: {
    margin: 0,
    padding: theme.spacing(3)
  },
  subHeading: {
    marginBottom: theme.spacing(4)
  },
  content: {
    padding: theme.spacing(3)
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  text: {
    flexGrow: 1,
    marginRight: theme.spacing(2)
  },
  buttons: {
    flexGrow: 0
  },
  deleteButton: {
    color: theme.palette.error.main
  }
}));

interface KeysProps {
  data: string | null
}

export default function Keys ({ data }: KeysProps) {
  const classes = useStyles();
  const [apiKey, setApiKey] = useState(data);

  const handleDeleteClick = async () => {
    const { apiKey: deletedKey } = await fetcher.del('/api/user/api-key').json();
    setApiKey(deletedKey);
  };

  const handleCreateClick = async () => {
    const { apiKey: newKey } = await fetcher.post('/api/user/api-key').json();
    setApiKey(newKey);
  };

  return (
    <Container maxWidth='lg' className={classes.root}>
      <Typography component='h1' variant='h2' className={classes.heading}>
        <Translate content='account_api_title' />
      </Typography>
      <Divider />
      <div className={classes.content}>
        <Typography component='h2' variant='h3' className={classes.subHeading}>
          <Translate content='keys_key_management' />
        </Typography>
        <Typography component='h3' variant='h4'>
          <Translate content='keys_api_key' />
        </Typography>
        {apiKey
          ? (
            <>
              <CodeSnippet codeTag={apiKey} copyToClipboard />
              <Button variant='text' className={classes.deleteButton} onClick={handleDeleteClick}>
                <Translate content='delete' />
              </Button>
            </>
            )
          : (
            <div className={classes.row}>
              <div className={classes.text}>
                <Translate content='keys_no_api_key' />
              </div>
              <div className={classes.buttons}>
                <Button variant='contained' color='primary' onClick={handleCreateClick}>
                  <Translate content='keys_create' />
                </Button>
              </div>
            </div>
            )}
      </div>
    </Container>
  );
}
